<!-- @format -->

<template>
	<div class="rejilla" :class="{ 'rejilla--doble': dosColumnas }">
		<v-card
			v-for="orden in ordenes"
			:key="orden.clave"
			outlined
			class="mb-3 tarjeta-ot"
			:class="orden.esCertificada ? 'tarjeta-ot--certificada' : 'tarjeta-ot--pendiente'"
		>
			<div class="d-flex align-center px-3 pt-3">
				<v-checkbox
					:input-value="seleccion.some(item => item.clave === orden.clave)"
					hide-details
					class="mt-0 pt-0 mr-2"
					:aria-label="`Seleccionar OT ${orden.folio}`"
					@change="valor => $emit('alternar', { orden, valor })"
				/>
				<div class="text-h6 font-weight-bold mr-2">OT {{ orden.folio }}</div>
				<v-chip
					small
					label
					:color="orden.esCertificada ? 'success' : 'warning'"
					text-color="white"
				>
					{{ orden.esCertificada ? 'Certificada' : 'Por certificar' }}
				</v-chip>
				<v-spacer />
				<v-icon :color="orden.tipoColor">{{ orden.tipoIcono }}</v-icon>
			</div>

			<v-card-text class="py-2">
				<div class="d-flex align-start mb-1">
					<v-icon small class="mr-2 mt-1">mdi-office-building-marker-outline</v-icon>
					<span class="body-2 font-weight-medium">{{ orden.lugar }}</span>
				</div>
				<div class="d-flex align-center mb-1">
					<v-icon small class="mr-2">mdi-account-hard-hat</v-icon>
					<span class="body-2">{{ orden.tecnico }}</span>
				</div>
				<div class="d-flex align-center flex-wrap">
					<v-icon small class="mr-2">mdi-calendar-blank-outline</v-icon>
					<span class="body-2 mr-3">Actividad {{ fecha(orden.fechaActividad) }}</span>
					<span class="body-2 text--secondary">OT {{ fechaHora(orden.fechaOT) }}</span>
				</div>
				<div class="mt-2 d-flex flex-wrap">
					<v-chip x-small class="mr-1" :color="orden.tipoColor" text-color="white">
						{{ orden.tipoEtiqueta }}
					</v-chip>
					<v-chip v-if="orden.emergencia" x-small color="error" outlined class="mr-1">
						Emergencia
					</v-chip>
					<v-chip v-if="orden.compartida" x-small color="success" outlined class="mr-1">
						En el portal
					</v-chip>
					<v-chip v-if="orden.tieneFirma === false" x-small color="error" outlined>
						Sin firma
					</v-chip>
				</div>
			</v-card-text>

			<v-divider />

			<v-card-actions class="pa-3">
				<work-order-row-actions
					class="w-100"
					grande
					:orden="orden"
					:descargando="descargando === orden.clave"
					:compartiendo="compartiendo === orden.clave"
					@compartir="item => $emit('compartir', item)"
					@descargar="item => $emit('descargar', item)"
					@copiar="item => $emit('copiar', item)"
				/>
			</v-card-actions>
		</v-card>

		<data-empty
			v-if="!ordenes.length && !cargando"
			title="Sin órdenes"
			msj="No hay órdenes de trabajo para los filtros aplicados"
			:height="120"
		/>

		<div v-if="cargando" class="text-center py-4">
			<v-progress-circular indeterminate color="primary" />
		</div>
	</div>
</template>

<script>
import { textoFecha, textoFechaHora } from '@/utils/workOrders/fechas';

export default {
	name: 'WorkOrderCards',
	components: {
		DataEmpty: () => import('@/components/ui/DataEmpty.vue'),
		WorkOrderRowActions: () => import('./WorkOrderRowActions.vue'),
	},
	props: {
		ordenes: { type: Array, default: () => [] },
		seleccion: { type: Array, default: () => [] },
		cargando: { type: Boolean, default: false },
		descargando: { type: String, default: '' },
		compartiendo: { type: String, default: '' },
		dosColumnas: { type: Boolean, default: false },
	},
	methods: {
		fecha: textoFecha,
		fechaHora: textoFechaHora,
	},
};
</script>

<style scoped>
/* en tablet horizontal caben dos tarjetas por fila sin desperdiciar ancho */
.rejilla--doble {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 0 12px;
	align-items: start;
}
.rejilla--doble > .v-card:last-child {
	grid-column: auto;
}
.rejilla {
	max-width: 1500px;
	margin: 0 auto;
	padding: 0 7px;
}
.tarjeta-ot {
	border: 1px solid #cad8dd;
	border-left-width: 4px;
	border-left-style: solid;
	border-radius: 10px;
}
.tarjeta-ot--certificada {
	border-left-color: #4caf50;
}
.tarjeta-ot--pendiente {
	border-left-color: #fb8c00;
}
.w-100 {
	width: 100%;
}
</style>
